import { useTheme } from '../hooks/useTheme'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  variant?: 'light' | 'dark'
  className?: string
}

const sizeStyles = {
  sm: { fontSize: '20px', dotSize: 5, glowSize: 8 },
  md: { fontSize: '28px', dotSize: 8, glowSize: 12 },
  lg: { fontSize: '56px', dotSize: 12, glowSize: 20 },
}

export default function Logo({ size = 'md', variant = 'light', className = '' }: LogoProps) {
  const { resolvedTheme } = useTheme()
  const { fontSize, dotSize, glowSize } = sizeStyles[size]
  const textColor = variant === 'light' ? '#ffffff' : 'var(--text-primary)'
  const isDark = resolvedTheme === 'dark'

  return (
    <div className={`flex items-center ${className}`}>
      <span
        className="no-theme-transition"
        style={{
          fontFamily: "'Sora', sans-serif",
          fontSize,
          fontWeight: 700,
          color: textColor,
          letterSpacing: '-1px',
          lineHeight: 1,
        }}
      >
        lentals
        <span
          className="no-theme-transition"
          style={{
            display: 'inline-block',
            width: dotSize,
            height: dotSize,
            background: isDark ? '#e8a060' : '#d4956b',
            borderRadius: '50%',
            marginLeft: 3,
            verticalAlign: 'middle',
            boxShadow: isDark
              ? `0 0 ${glowSize}px rgba(232, 160, 96, 0.6), 0 0 ${glowSize * 2}px rgba(232, 160, 96, 0.3)`
              : 'none',
            transition: 'box-shadow 0.3s ease, background 0.3s ease',
          }}
        />
      </span>
    </div>
  )
}
